import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPathname } from '../../../modules/app/selectors';

const Tabs = ({ children, className, currentPath }) => (
  <div className={classnames('tabs', className)}>
    <ol className="tabs__bar">
      {
        React.Children.map(children, child => {
          const { label, url } = child.props;
          return (
            <li
              className={classnames('tabs__label', {
                'tabs__label--selected': url === currentPath
              })}
            >
              <Link className="tabs__link" to={url}>
                {label}
              </Link>
            </li>
          );
        })
      }
    </ol>
    <div className="tabs__content">
      {React.Children.map(children, child => {
        const { url, children: tabContent } = child.props;
        return (url === currentPath) && (
          <React.Fragment>
            {tabContent}
          </React.Fragment>
        );
      })}
    </div>
  </div>
);

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  currentPath: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  currentPath: getPathname(state)
});

export default connect(mapStateToProps)(Tabs);
